import { Node, ReactNodeViewRenderer } from '@tiptap/react';
import { OurServicesBlockView } from './OurServicesBlockView';

export const OurServices = Node.create({
    name: 'ourservices',

    group: 'block',

    defining: true,

    isolating: true,

    parseHTML() {
        return [
            {
                tag: `div[data-type="${this.name}"]`,
            },
        ];
    },

    renderHTML() {
        return [
            'div',
            {
                'data-type': 'ourservices',
                class: 'ourservices-block',
            },
            'Our Services Block'
        ];
    },

    addCommands() {
        return {
            setOurServices:
                () =>
                    ({ commands }) => {
                        return commands.insertContent({
                            type: this.name,
                        });
                    },
        };
    },

    addNodeView() {
        return ReactNodeViewRenderer(OurServicesBlockView);
    },
});